import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseDataSource } from './base.datasource';
import { DataSourceParams, IBaseTableResult } from 'app/store/models/table.model';

interface IExtraConfig {
  include: boolean;
  column: string;
}

interface IApiDataSourceConfig {
  extra: IExtraConfig;
}

export class ApiDataSource<T> extends BaseDataSource<T> {
  private apiEndpoint: string;
  private http: HttpClient;
  private readonly config: IApiDataSourceConfig;

  constructor(
    http: HttpClient,
    apiEndpoint: string,
    config?: IApiDataSourceConfig,
  ) {
    super();
    this.http = http;
    this.apiEndpoint = apiEndpoint;
    this.config = config;
  }

  loadData(data: DataSourceParams): Observable<IBaseTableResult<T>> {
    const params = {
      page: String(data.page),
      page_size: String(data.pageSize),
      sort_attr: String(data.sortAttr),
      sort_dir: String(data.sortDir),
    };

    const searchParams = new URLSearchParams();
    if (data.filters) {
      for (const filter in data.filters) {
        if (data.filters[filter]) {
          params[filter] = data.filters[filter];
        }
      }
    }
    for (const key in params) {
      if (params[key]) {
        searchParams.append(key, params[key]);
      }
    }

    let controlChar = '?';

    if (this.apiEndpoint.indexOf('?') > -1) {
      controlChar = '&';
    }

    return this.http
      .get<IBaseTableResult<T>>(this.apiEndpoint + controlChar + searchParams.toString())
      .pipe(
        map(result => {
          if (this.config && this.config.extra.include) {
            const items = [];
            result.items.forEach(item => {
              const tmp = item[this.config.extra.column];
              delete item[this.config.extra.column];
              items.push(item, { [this.config.extra.column]: tmp, item });
            });

            return {
              ...result,
              items,
            };
          }

          return result;
        }),
      );
  }
}
